<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="error error-5 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
      }"
    >
      <!-- begin:: Content -->
      <div
        class="container d-flex flex-row-fluid flex-column justify-content-md-center py-12"
      >
        <img
          src="/media/logos/soha-logo.png"
          width="100"
          class="mx-auto my-5"
        />
        <h1
          class="display-2 font-weight-boldest primary-color mt-10 mt-md-0 mb-12 mx-auto"
        >
          {{ $t(`${I18nPrefix}SORRY`) }}
        </h1>
        <p class="font-weight-boldest text-center" style="font-size: 1.5rem">
          {{ $t(`${I18nPrefix}DESCRIPTION`) }}
        </p>
        <p class="font-size-h3 mx-auto">
          <router-link :to="{ name: 'dashboard' }">
            {{ $t(`${I18nPrefix}DASHBOARD`) }}
          </router-link>
        </p>
      </div>
      <!-- end:: Content -->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error.scss";
</style>

<script>
export default {
  name: "Error-5",
  data() {
    return {
      I18nPrefix: "PAGES.ERROR.ERROR.",
    };
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/error/bg5.jpg";
    },
  },
};
</script>
